'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled, { css } from 'styled-components';
import { secondaryColor } from '../constant.js';

var Button = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 10px 24px;\n    border-radius: 3px;\n    font-size: 14px;\n    line-height: 20px;\n    outline: none;\n    border: none;\n    cursor: pointer;\n\n    ", "\n"], ["\n    padding: 10px 24px;\n    border-radius: 3px;\n    font-size: 14px;\n    line-height: 20px;\n    outline: none;\n    border: none;\n    cursor: pointer;\n\n    ", "\n"])), function (_a) {
    var type = _a.type;
    switch (type) {
        case 'primary':
            return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                    background-color: ", ";\n                    color: white;\n                "], ["\n                    background-color: ", ";\n                    color: white;\n                "])), secondaryColor);
        default:
            return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                    background-color: ", ";\n                    color: white;\n                "], ["\n                    background-color: ", ";\n                    color: white;\n                "])), secondaryColor);
    }
});
var templateObject_1, templateObject_2, templateObject_3;

export { Button };
//# sourceMappingURL=ButtonPrimary.css.js.map
